<template>
  <div id="hst-request-search-detail">
    <div id="container">
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 案件確認詳細</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back"
          >戻る</b-button
        >
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td>{{ item.receiptNumber }}</td>
            </tr>
            <tr>
              <th>デモ</th>
              <td><span v-if="item.demo">デモ</span></td>
            </tr>
            <tr>
              <th>機種</th>
              <td>{{ getKind(item.modelId) }}</td>
            </tr>
            <tr v-if="isWP300(item.modelId)">
              <th>いびきセンサー同梱の有無</th>
              <td>{{setSnoreSensorValue(item.snoreSensor)}}</td>
            </tr>
            <tr>
              <th>ステータス</th>
              <td class="align-item-center">
                <span :class="getTagClass(item.status)">
                  {{ getStatusName(item.status) }}
                </span>
                <template v-if="item.status == 16">
                  <b-icon class="arrow-icon" icon="arrow-right-bold-outline" />
                  <b-button class="is-primary b-button" @click="confirmReExamination"
                    >再検査を実施する</b-button
                  >
                  <b-button
                    class="is-primary b-button"
                    @click="cancelReasonInputModalActive = true"
                    >検査をキャンセル</b-button
                  >
                </template>
              </td>
            </tr>
            <tr>
              <th>シリアル</th>
              <td class="align-item-center">
                {{ item.serial }}
                <b-button
                  v-if="item.serial && item.status == 3"
                  class="b-button"
                  @click="changeDeviceModalActive = true"
                  >予約機器変更</b-button
                >
              </td>
            </tr>
            <tr v-if="isNightGraf(item.modelId)">
              <th>電極のロット</th>
              <td>
                {{ item.electrodeLot }}
              </td>
            </tr>
            <tr v-if="isNightGraf(item.modelId)">
              <th>カニューラのロット</th>
              <td>
                {{ item.cannulaLot }}
              </td>
            </tr>
            <tr>
              <th>支店名</th>
              <td>
                {{ item.branchOfficeName }}
              </td>
            </tr>
            <tr>
              <th>担当者名</th>
              <td>
                {{ item.salesStaffName }}
              </td>
            </tr>
            <tr>
              <th>依頼元</th>
              <td>
                {{ item.client }}
                <span v-if="item.proxyFlag" class="agent" />
              </td>
            </tr>
            <tr></tr>
            <tr>
              <th>患者名</th>
              <td>{{ item.patientName }}</td>
            </tr>
            <tr>
              <th>性別</th>
              <td>{{ item.gender }}</td>
            </tr>
            <tr>
              <th>生年月日</th>
              <td>{{ item.birthday }}</td>
            </tr>
            <tr></tr>
            <tr>
              <th>送り状番号</th>
              <td>{{ item.invoiceNumber }}</td>
            </tr>
            <tr>
              <th>着払い番号</th>
              <td>{{ item.paymentNumber }}</td>
            </tr>
            <tr></tr>
            <tr>
              <th>受付日</th>
              <td>{{ item.receptionDate }}</td>
            </tr>
            <tr>
              <th>出荷日</th>
              <td>{{ item.shippingDate }}</td>
            </tr>
            <tr>
              <th>機器返却日</th>
              <td>{{ item.returnDate }}</td>
            </tr>
            <tr>
              <th>解析依頼日</th>
              <td>{{ item.analysisRequestDate }}</td>
            </tr>
            <tr>
              <th>解析日</th>
              <td>{{ item.analysisDate }}</td>
            </tr>
            <tr>
              <th>完了日</th>
              <td>{{ item.completionDate }}</td>
            </tr>
          </table>

          <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
            <ReasonInputModal
              :title="'検査キャンセル(キャンセル理由入力)'"
              @setReason="cancelInspection"
            />
          </b-modal>

          <b-modal :active.sync="changeDeviceModalActive" has-modal-card>
            <ChangeDeviceModal
              :oldSerialNumber="item.serial"
              :model="item.modelId"
              :choicesType="devices"
              :receptionNo="item.receiptNumber"
              :type="'HST'"
              @save="setNewSerial"
            />
          </b-modal>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { role, reExaminationConfirmTemplate, hstModelValue } from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import { choicesType } from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import ChangeDeviceModal from "@/components/mock/philips/common/ChangeDeviceModal";

export default {
  data() {
    return {
      item: "",
      devices: "",
      statusList: "",
      searchConditions: "",
      cancelReason: "",
      cancelReasonInputModalActive: false,
      changeDeviceModalActive: false,
      hstModelValue: hstModelValue,
    };
  },

  components: {
    ReasonInputModal: reasonInputModal,
    ChangeDeviceModal,
  },

  methods: {
    back() {
      this.$router.push({
        name: "HSTRequestSearch",
        params: { searchConditions: this.searchConditions },
      });
    },
    getStatusName(statusCode) {
      var target = this.statusList.find(
        (val) => val.value && val.value.includes(statusCode)
      );
      if (target) {
        return target.name;
      }
      return "";
    },

    setNewSerial(newSerial) {
      this.item.serial = newSerial;
    },
    // 再検査実施前の確認ダイアログ表示
    confirmReExamination() {
      this.$dialog.confirm({
        title: "　",
        message: reExaminationConfirmTemplate.message,
        cancelText: reExaminationConfirmTemplate.cancelText,
        confirmText: reExaminationConfirmTemplate.confirmText,
        onConfirm: () => {
          this.doReInspection();
        },
      });
    },
    doReInspection: function() {
      //再検査を実施する
      let _this = this;
      var shortestShippingDateList = this.getShortestShippingDate()
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalRequestSearch.doReInspectionPOST({
            body:{
                kind: "hst",                
                receiptNumber:_this.item.receiptNumber,
                shortestShippingDateList:shortestShippingDateList,
                version: _this.item.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.item.status =  requestStatus.deviceReady;
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    cancelInspection: function(reason){
      //検査をキャンセル
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalRequestSearch.cancelInspectionPOST({
            body:{
                kind: "hst",                
                receiptNumber:_this.item.receiptNumber,
                reason: reason,
                version: _this.item.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.item.status =  requestStatus.cancel;
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    isWP300: function(modelId) {
      if(modelId == hstModelValue.WP300){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = snoreSensor == "1" ? "無" : "有";
      return setSnoreSensorValue
    },
    isNightGraf: function(modelId) {
      if(modelId == hstModelValue.NIGHTGRAF){
        return true
      }
      return false
    },
  },

  created() {
    this.item = this.$route.params.item;
    this.devices = choicesType.hstKind;
    this.searchConditions = this.$route.params.searchConditions;
    this.statusList = this.$route.params.statusList;
  },
};
</script>

<style scoped>
.tag {
  width: 150px !important;
  height: 36px !important;
}

.arrow-icon {
  width: 20px !important;
}

.b-button {
  width: 150px !important;
  margin-left: 5px !important;
}

.align-item-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTRequestSearchDetail.vue